<template>
  <div class="timeAxis" :style="{ marginTop: `${data.top}px` || 0 }">
    <div class="timeAxis-axis">
      <div class="timeAxis-axis-blue" />
      <div class="timeAxis-axis-gray" />
    </div>
    <div class="timeAxis-content">
      <div class="timeAxis-content-time">{{ data.time }}</div>
      <div class="timeAxis-content-title">{{ data.title }}</div>
      <div class="timeAxis-content-desc">{{ data.desc }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="less" scoped>
.timeAxis {
  display: flex;
  .timeAxis-axis {
    width: 106px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    .timeAxis-axis-blue {
      width: 100%;
      height: 57px;
      background: url("../../static/img/about/axis_blue.png") no-repeat 0 0 /
        100% 100%;
    }
    .timeAxis-axis-gray {
      width: 100%;
      flex: 1;
      background: url("../../static/img/about/axis_gray.png") repeat-y 0 0 /
        100% auto;
    }
  }
  .timeAxis-content {
    padding: 32px;
    width: calc(100% - 120px);
    .timeAxis-content-time {
      font-size: 36px;
      font-weight: bold;
      color: #08204d;
      line-height: 48px;
      letter-spacing: 1px;
    }
    .timeAxis-content-title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin: 8px 0;
      font-weight: bold;
    }
    .timeAxis-content-desc {
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/timeAxis.vue